module.exports = __webpack_public_path__ + "static/bintang2-96822ba6659e6a517f6381219c7237d8.mp4";